module.exports = __webpack_public_path__ + "img/tablet-landscape-fill.d653bac2.svg";